import type { ComponentType } from 'react';
import type { AppRoute, AppRouteId } from '../routes/appRoutes';
import B2BInquiryManagementPage from './B2BInquiryManagementPage';
import CategoriesPage from './CategoriesPage';
import CertificateTemplatePage from './CertificateTemplatePage';
import DeviceManagementPage from './DeviceManagementPage';
import EventInfoPage from './EventInfoPage';
import EventListPage from './EventListPage';
import EventReaderDevicesPage from './EventReaderDevicesPage';
import GoodsRepresentativeImagePage from './GoodsRepresentativeImagePage';
import NoticeManagementPage from './NoticeManagementPage';
import LeaderboardPage from './LeaderboardPage';
import HomepageUserManagementPage from './HomepageUserManagementPage';
import LoginPage from './LoginPage';
import LoginVerifyPage from './LoginVerifyPage';
import PasswordResetPage from './PasswordResetPage';
import ParticipantsPage from './ParticipantsPage';
import QnaManagementPage from './QnaManagementPage';
import RawDataPage from './RawDataPage';
import ResultsPage from './ResultsPage';
import SplitsPage from './SplitsPage';
import StatisticsCumulativePage from './StatisticsCumulativePage';
import StatisticsLivePositionPage from './StatisticsLivePositionPage';
import StatisticsSplitPage from './StatisticsSplitPage';
import StatisticsSummaryPage from './StatisticsSummaryPage';
import TimingPointsPage from './TimingPointsPage';
import UserManagementPage from './UserManagementPage';

type PageRouterProps = Readonly<{
  route: AppRoute;
}>;

const pageComponents: Record<AppRouteId, ComponentType> = {
  login: LoginPage,
  'login-verify': LoginVerifyPage,
  'password-reset': PasswordResetPage,
  'signup-password': PasswordResetPage,
  'event-list': EventListPage,
  'device-management': DeviceManagementPage,
  'notice-management': NoticeManagementPage,
  'b2b-inquiry-management': B2BInquiryManagementPage,
  'qna-management': QnaManagementPage,
  'certificate-template': CertificateTemplatePage,
  'homepage-user-management': HomepageUserManagementPage,
  'goods-representative-image': GoodsRepresentativeImagePage,
  'user-management': UserManagementPage,
  'event-info': EventInfoPage,
  'timing-points': TimingPointsPage,
  categories: CategoriesPage,
  splits: SplitsPage,
  participants: ParticipantsPage,
  'event-reader-devices': EventReaderDevicesPage,
  'statistics-summary': StatisticsSummaryPage,
  'statistics-split': StatisticsSplitPage,
  'statistics-live-position': StatisticsLivePositionPage,
  'statistics-cumulative': StatisticsCumulativePage,
  leaderboard: LeaderboardPage,
  results: ResultsPage,
  'raw-data': RawDataPage,
};

function PageRouter({ route }: PageRouterProps) {
  const PageComponent = pageComponents[route.id];

  return <PageComponent />;
}

export default PageRouter;
